registerComponent("sections/newsletter", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * 209 linhas viraram estas: tudo que era jQuery Validate, jquery.mask e
 * `$.ajax` está em `Asa.formulario`, que os cinco formulários do site legado
 * passam a dividir. Aqui fica só o que é da newsletter — as regras do
 * telefone, a máscara e as três telas.
 *
 * O que MUDA de comportamento, e por quê:
 *
 * - **O envio manda `Accept: application/json`** (é `Asa.formulario` quem
 *   manda, e não é opção). Sem esse cabeçalho o `$request->validate` do
 *   `Api\NewsletterController` responde 302; o `$.ajax` de 2020 seguia o
 *   redirect, recebia HTML e caía no `error:` — a pessoa via a tela de erro
 *   genérica sem saber qual campo estava errado. Agora um 422 vira mensagem
 *   POR CAMPO, e a tela de erro fica para o que ela sempre foi: falha de rede,
 *   5xx, e o `error: true` que o controller pode devolver com 200.
 * - `keyup` → `input` nos campos (ver `blocks/input`).
 *
 * O que NÃO muda: o cliente continua mandando o telefone MASCARADO, que é o
 * que `$form.serialize()` mandava e o que está gravado nos 681 leads.
 */

// i18n — o mesmo `isEn` dos cinco formulários de 2020, lido do <html>.
const isEn = (document.documentElement.lang || '').toLowerCase().startsWith('en');
const isPt = !isEn;

const form = component.querySelector('#formNewsletter');
const sucesso = component.querySelector('.success');
// Classe `.error-screen` (não `.error`) para não colidir com a classe `error`
// que `Asa.formulario` põe nos campos inválidos.
const erro = component.querySelector('.error-screen');
const voltar = component.querySelector('.btn-back-error');
const telefone = component.querySelector('#cellphoneNewsletter');

/*
 | ⚠️ `display: block`, não `''`. `.success` e `.error-screen` nascem
 | `display: none` PELA FOLHA (`_newsletter.less`), e não por estilo inline —
 | o `.show()` do jQuery caía no display padrão da tag, que para uma `div` é
 | `block`. Transpor como `''` devolveria `none` e a tela de sucesso não
 | apareceria, sem erro nenhum no console. É a correção 67, de novo.
 |
 | O `<form>`, ao contrário, sai de `display` da folha e volta para ele: ali
 | `''` é o certo, porque foi o JS que escreveu o `none`.
 */
const mostrarTela = (tela) => {
    form.style.display = tela === 'form' ? '' : 'none';
    sucesso.style.display = tela === 'sucesso' ? 'block' : 'none';
    erro.style.display = tela === 'erro' ? 'block' : 'none';
};

if (voltar) {
    voltar.addEventListener('click', function () {
        mostrarTela('form');
    });
}

/*
 | A máscara do telefone.
 |
 | PT: a máscara dinâmica de 2020 — 11 dígitos viram `(00) 00000-0000`, menos
 | do que isso fica em `(00) 0000-00009`. Era o `maskBehavior` + `onKeyPress`
 | do jquery.mask; aqui a função é reavaliada a cada `input`, que dá o mesmo
 | resultado com menos peças.
 |
 | EN: o telefone estrangeiro não tem formato fixo, e 2020 só filtrava os não
 | dígitos em tempo real. Uma máscara de N tokens `0`, N = quantos dígitos já
 | foram digitados, é exatamente esse filtro dentro do mesmo contrato.
 */
const mascaraDoTelefone = isPt
    ? (valor) => (valor.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009')
    : (valor) => '0'.repeat(Math.max(1, valor.replace(/\D/g, '').length));

if (telefone && isEn) {
    // Teclado numérico no celular; era o mesmo atributo, posto pelo mesmo JS.
    telefone.setAttribute('inputmode', 'numeric');
}

Asa.formulario(form, {
    action: 'api/newsletter',
    regras: {
        cellphoneNewsletter: {
            // `celular: (isPt) ? true : false` — o DDD e o 9 na frente são
            // regra brasileira e só valem em pt.
            celular: isPt,
            minlength: 7,
        },
        emailNewsletter: {
            email: true,
        },
    },
    mensagens: {
        cellphoneNewsletter: {
            minlength: isEn ? 'Invalid mobile phone number.' : 'Informe um celular válido.',
        },
    },
    mascaras: {
        cellphoneNewsletter: mascaraDoTelefone,
    },
});

/*
 | As três telas. `formulario:enviando` chega DEPOIS de o `FormData` estar
 | montado (o contrato está no cabeçalho de `Asa.formulario`), então
 | desabilitar os campos aqui não esvazia o corpo do POST — que é o que
 | aconteceria se a ordem fosse a outra.
 */
const campos = () => Array.from(form.querySelectorAll('input'));

form.addEventListener('formulario:enviando', function () {
    campos().forEach((campo) => {
        campo.disabled = true;
    });
});

form.addEventListener('formulario:sucesso', function () {
    campos().forEach((campo) => {
        campo.disabled = false;
    });

    mostrarTela('sucesso');
});

form.addEventListener('formulario:erro', /** @param {CustomEvent} evento */ function (evento) {
    campos().forEach((campo) => {
        campo.disabled = false;
    });

    /*
     | 422 com erros por campo não troca de tela: as mensagens já estão nas
     | `label.error`, ao lado do campo que as causou, e esconder o formulário
     | esconderia justamente a informação nova. A tela de erro continua
     | valendo para tudo o mais — 5xx, falha de rede, e o `error: true` que o
     | controller pode devolver com 200.
     */
    if (evento.detail && evento.detail.erros) {
        return;
    }

    mostrarTela('erro');
});

});
